import { createRouter, createWebHistory, Router } from 'vue-router';
import routes from './routes';

const router: Router = createRouter({
	history: createWebHistory(),
	routes,
});

router.beforeEach(async (to) => {
	const userStore = useUserStore();
	if (!userStore.user) {
		await fetcher(userStore.authenticate());
	}
	
	if (to.meta.role === 'public') {
		return true;
	}
	
	if (to.meta?.role && userStore.user?.data?.role !== to.meta.role) {
		return {
			name: 'message-threads',
		};
	}

	if (!userStore.user && to.name !== 'login' && to.meta.role !== 'public') {
		return {
			name: 'login',
		};
	}

	return true;
});

export default router;
